import { useEffect, useState } from 'react';
import {
  Grid, Typography, Container
} from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

import LoginForm from '../../components/auth/LoginForm';
import { login, loginRed, loginFacebook } from '../../actions/auth';
import { isEmpty } from '../../components/common/helpers';
import { useDestinoAlEntrar } from '../../utils/destinoAlEntrar';

import { useDispatch, useSelector } from 'react-redux';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const errors = useSelector(state => state.auth.error);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  // Al entrar regresa adonde iba (la pantalla privada, el servicio donde tocó «Cotizar»…) o, si no hay nada, al inicio
  const destino = useDestinoAlEntrar(isAuthenticated);

  const [error, setError] = useState({
    email: '',
    password: ''
  });

  useEffect(() => {
    const email = errors?.find(info => info.param === 'email');
    const password = errors?.find(info => info.param === 'password');
    const err = {
      email: '',
      password: ''
    }
    if (!isEmpty(email)) {
      err.email = email.msg
    }
    if (!isEmpty(password)) {
      err.password = password.msg
    }
    setError({
      email: err.email,
      password: err.password
    })
  }, [errors]);

  const irA = where => e => {
    e.preventDefault();
    navigate(where);
  }

  const onSubmit = async (email, pass) => {
    await dispatch(login(email, pass));
  }

  const responseGoogle = useGoogleLogin({
    onSuccess: async (credentialResponse) => {
      try {
        localStorage.setItem('access_token', credentialResponse.access_token);
        // Usar el access_token para obtener los datos del usuario
        const userInfo = await axios.get(
          'https://www.googleapis.com/oauth2/v1/userinfo?alt=json',
          {
            headers: {
              Authorization: `Bearer ${credentialResponse.access_token}`,
              Accept: 'application/json',
            },
          }
        );
        // El servidor comprueba el token con Google y toma de ahí el correo y el nombre. Los demás campos solo
        // los lee el servidor anterior (que no verificaba nada); se pueden quitar cuando el nuevo esté desplegado.
        const data = {
          accessToken: credentialResponse.access_token,
          email: userInfo.data.email,
          name: userInfo.data.given_name,
          apellido: userInfo.data.family_name,
        };
        dispatch(loginRed(data));
      } catch (error) {
        console.error('Error fetching user info:', error);
      }

    },
    onError: () => {
      console.log('Login Failed');
    },
  });

  //Redirect (`replace`: el login no se queda en el historial)
  if (isAuthenticated) {
    return <Navigate to={destino} replace />
  }

  // El SDK de Facebook devuelve { accessToken, userID, ... }. Solo mandamos el accessToken;
  // el backend lo verifica con el Graph API y obtiene el email/nombre reales.
  const responseFacebook = response => {
    if (!response?.accessToken) return;
    dispatch(loginFacebook(response.accessToken));
  }

  return (
    <Container
      sx={{
        flex: 1, // Ocupa el espacio disponible entre el header y el footer
        display: 'flex',
        alignItems: { xs: 'flex-start', md: 'center' }, // Center vertically on md+, start on mobile
        justifyContent: 'center',
      }}
    >
      <Grid container spacing={3}
        sx={{
          maxWidth: 'lg',
          flexDirection: { xs: 'column', md: 'row' }, // Stack on mobile, row on md+
          alignItems: { xs: 'center', md: 'center' }, // Center items
          justifyContent: 'center',
        }}>
        <Grid className="logo-login" size={{ xs: 12, md: 6 }}>
          <img width="400" src="/logo-os-24.svg" alt="OneService" />
          <Typography variant='h3' color="primary" mt={3}>
            "Encuentra y ofrece servicios en un solo lugar."
          </Typography>
        </Grid>
        { /*Formulario de login */}
        <LoginForm
          onSubmit={onSubmit}
          google={responseGoogle}
          facebook={responseFacebook}
          irA={irA}
          error={error}
        />
      </Grid>
    </Container>
  );
}

export default Login;